import script from "./Role.vue?vue&type=script&setup=true&lang=js"
export * from "./Role.vue?vue&type=script&setup=true&lang=js"

import "./Role.vue?vue&type=style&index=0&id=31e2e362&lang=scss"

const __exports__ = script;

export default __exports__